import axios from "axios";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_ENDPOINT } from "./constants";
const APP_TOKEN = "app_token";
const AI_MODE = "ai_mode";
const AI_OPEN = "ai_open";
const TEMPLATES_LIST = "templates_list";
const AI_FULLSCREEN = "ai_fullscreen";

export const setAiMode = (token) => {
  localStorage.setItem(AI_MODE, token);
};
export const getAiMode = () => {
  return localStorage.getItem(AI_MODE);
};
export const setTemplatesList = (token) => {
  localStorage.setItem(TEMPLATES_LIST, token);
};
export const getTemplatesList = () => {
  return JSON.parse(localStorage.getItem(TEMPLATES_LIST));
};
export const setAiOpen = (token) => {
  localStorage.setItem(AI_OPEN, token);
};
export const getAiOpen = () => {
  return localStorage.getItem(AI_OPEN);
};
export const setAiFullScreen = (token) => {
  localStorage.setItem(AI_FULLSCREEN, token);
};
export const getAiFullScreen = () => {
  return localStorage.getItem(AI_FULLSCREEN);
};
export const deleteToken = () => {
  localStorage.removeItem(APP_TOKEN);
};
export const saveToken = (token) => {
  localStorage.setItem(APP_TOKEN, token);
};
export const getToken = () => {
  return localStorage.getItem(APP_TOKEN);
};
export const getHeader = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};
export function getErrorResponse(error) {
  if (error.response && error.response.data && error.response.data.error) {
    const errorData = error.response.data.error;
    return typeof errorData !== "string"
      ? JSON.stringify(errorData)
      : errorData;
  } else if (
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    const messageData = error.response.data.message;
    return typeof messageData !== "string"
      ? JSON.stringify(messageData)
      : messageData;
  } else {
    return "An error occurred. Please try again.";
  }
}
export function capitalizeFirstLetter(string) {
  if (!string || typeof string !== "string") return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const getMultipartHeader = () => {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: `Bearer ${getToken()}`,
    },
  };
};
export const isLoggedIn = () => {
  return localStorage.getItem(APP_TOKEN) !== null;
};
export const UserAuth = ({ children }) => {
  return isLoggedIn() ? children : <Navigate to="/login" />;
};

export function toastError(error) {
  toast.error(getErrorResponse(error));
}
export async function synContactsList() {
  try {
    const response = await axios.get(
      `${API_ENDPOINT}/api/get-templates-sync`,
      getHeader()
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
export function toCamelCase(str) {
  return str
    .replace(/[^a-zA-Z0-9\s_-]/g, "") // Remove special characters except spaces, underscores, and hyphens
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+|[-_]+/g, ""); // Remove spaces, underscores, and hyphens
}

export function extractTemplateVars(template) {
  function getVars(text, prefix) {
    const vars = getVariableNames(template.parameter_format, text);
    return vars.map((item) => `${prefix}_${item}`);
  }
  const myVars = [];
  for (const comp of template.components ?? []) {
    switch (comp.type) {
      case "HEADER":
        myVars.push(...getVars(comp.text, "header"));
        break;
      case "BODY":
        myVars.push(...getVars(comp.text, "body"));
        break;
      default:
        break;
    }
  }
  return myVars;
}
export function getTemplateColumns(template) {
  function getVars(text, prefix) {
    const vars = getVariableNames(template.parameter_format, text);
    return vars.map((item) => `${prefix}_${item}`);
  }
  const myVars = [];
  for (const comp of template.components ?? []) {
    switch (comp.type) {
      case "BODY":
        myVars.push(...getVars(comp.text, "body"));
        break;
      default:
        break;
    }
  }
  return myVars;
}
export function applyTemplateVars(tpl, vars) {
  const template = structuredClone(tpl); // keep the original pristine
  template.components?.forEach((c) => {
    switch (c.type) {
      /* ---------- HEADER ---------- */
      case "HEADER": {
        const isNamed = template.parameter_format === "NAMED";
        if (isNamed) {
          (c.example?.header_text_named_params ?? []).forEach((p) => {
            const k = `header_${p.param_name}`;
            if (k in vars) p.example = vars[k];
          });
        } else {
          (c.example?.header_text ?? []).forEach((_, i, arr) => {
            const k = `header_${i + 1}`;
            if (k in vars) arr[i] = vars[k];
          });
        }
        break;
      }

      /* ---------- BODY ---------- */
      case "BODY": {
        const isNamed = template.parameter_format === "NAMED";

        if (isNamed) {
          (c.example?.body_text_named_params ?? []).forEach((p) => {
            const k = `body_${p.param_name}`;
            if (k in vars) p.example = vars[k];
          });
        } else {
          // body_text is an array *of* arrays: [ [ "20", "SALE20" ] ]
          const row = c.example?.body_text?.[0] ?? [];
          row.forEach((_, i) => {
            const k = `body_${i + 1}`;
            if (k in vars) row[i] = vars[k];
          });
        }
        break;
      }
      default:
        break;
    }
  });

  return template;
}
//MAIN
export function getTextHeaderPayload(template) {
  const header = template.components.find((item) => item.type === "HEADER");
  if (header) {
  } else {
    return null;
  }
}
export function getReplyVars(template) {
  const buttonsComponent = template.components?.find(
    (item) => item.type === "BUTTONS"
  );
  const quickReplies = buttonsComponent?.buttons?.filter(
    (btn) => btn.type === "QUICK_REPLY"
  );
  return quickReplies ?? [];
}
export function getBodyPreviewHtml(bodyObj) {
  if (!bodyObj || bodyObj.type !== "BODY") return "";

  /* ---------- 1.  SUBSTITUTE PLACEHOLDERS ---------- */
  let out = bodyObj.text;

  const { example = {} } = bodyObj;

  // Numbered {{1}}, {{2}}, …
  if (Array.isArray(example.body_text) && example.body_text.length) {
    const values = example.body_text[0]; // first row
    out = out.replace(/{{(\d+)}}/g, (_, rawIdx) => {
      const idx = Number(rawIdx) - 1; //   starts at 1
      return values[idx] ?? "";
    });
  }

  // Named {{param_name}}
  if (Array.isArray(example.body_text_named_params)) {
    const map = {};
    example.body_text_named_params.forEach(({ param_name, example }) => {
      map[param_name] = example;
    });
    out = out.replace(/{{(\w+)}}/g, (_, name) => map[name] ?? "");
  }

  /* ---------- 2.  APPLY TEXT FORMATTING ---------- */
  // Bold   – **text**   or *text*
  out = out.replace(
    /\*\*(.+?)\*\*|\*(.+?)\*/g,
    (_, a, b) => `<strong>${a || b}</strong>`
  );
  // Italic – __text__   or _text_
  out = out.replace(/__(.+?)__|_(.+?)_/g, (_, a, b) => `<em>${a || b}</em>`);
  // Strike – ~~text~~  or ~text~
  out = out.replace(/~~(.+?)~~|~(.+?)~/g, (_, a, b) => `<s>${a || b}</s>`);
  // Mono   – ```text```  (3-or-more back-ticks)
  out = out.replace(
    /```{1,}([\s\S]+?)```{1,}/g,
    (_, code) => `<code style="font-family:monospace;">${code}</code>`
  );
  return out;
}
export function getContactColumnNames(mongoObj) {
  const list = Object.keys(mongoObj).filter(
    (item) =>
      item !== "_id" &&
      item !== "createdOn" &&
      item !== "updatedOn" &&
      item !== "createdBy" &&
      item !== "customerId" &&
      item !== "groupName"
  );
  return list;
}
export const exportToExcel = async (
  exportData,
  fileName = "exported_data.xlsx",
  isColumnsList = false
) => {
  try {
    const XLSX = await import("xlsx");
    const worksheet = isColumnsList
      ? XLSX.utils.aoa_to_sheet(exportData)
      : XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  } catch (error) {
    console.error("Excel export failed", error);
    toast.error("Could not download the export. Check your connection and try again.");
  }
};
export function isValidUrl(url) {
  if (!url || typeof url !== "string" || url.trim() === "") return false;

  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch (_) {
    return false;
  }
}
export const validNoSpecialChar = ({
  label = "",
  value,
  setValue,
  setError,
  maxLength = 512,
}) => {
  const lowercaseValue = value.toLowerCase();
  const validPattern = /^[a-z0-9_]*$/;
  if (lowercaseValue.length > maxLength) {
    setError(`${label} must not exceed ${maxLength} characters`);
    return;
  }
  if (!validPattern.test(lowercaseValue)) {
    setError("Only lowercase letters, numbers, and underscores are allowed");
    return;
  }

  setError(""); // Clear error if input is valid
  setValue(lowercaseValue);
};

export const getVariableNames = (kind, text) => {
  const COUNT_VARIABLE_PATTERNS = {
    NAMED: /{{[^}]+}}/g,
    POSITIONAL: /{{\d+}}/g,
  };
  const patt = COUNT_VARIABLE_PATTERNS[kind];
  if (!patt) return [];
  return (text.match(patt) || []).map((s) => s.replace(/{{|}}/g, ""));
};
export const extractNumberedVariables = (text) => {
  const regex = /\{\{(\d+)\}\}/g;
  const matches = text.match(regex) || [];
  return matches.map((match) => parseInt(match.replace(/\{\{|\}\}/g, "")));
};
export function roundToMaxDecimals(num, maxDecimalPlaces = 2) {
  if (typeof num !== "number" || isNaN(num)) {
    return "NA";
  }
  const fixedString = num.toFixed(maxDecimalPlaces);
  return parseFloat(fixedString);
}
export function formatNumber(amount, locale = "en-IN", currency = "INR") {
  if (typeof amount !== "number") {
    return amount; // Return original value if not a number
  }

  const options = {
    // Specify the style. Set to 'currency' if a currency is provided.
    style: currency ? "currency" : "decimal",
    // Set the currency code if provided.
    currency: currency,
    // Add decimal digits for currency, unless it's a zero-decimal currency like JPY.
    minimumFractionDigits: currency ? 2 : 0,
    // Max 2 decimal digits for currency.
    maximumFractionDigits: currency ? 2 : undefined,
  };

  try {
    return new Intl.NumberFormat(locale, options).format(amount);
  } catch (e) {
    console.error("Failed to format number:", e);
    // Fallback to a simple comma function if Intl fails.
    return amount.toLocaleString(locale);
  }
}
export function validatePaymentAmount(amount, minAmount, maxAmount) {
  const parsedAmount = parseFloat(amount);
  // 1. Check if the amount is a valid number
  if (isNaN(parsedAmount) || !isFinite(parsedAmount)) {
    return {
      isValid: false,
      errorMessage: "Please enter a valid number for the amount.",
    };
  }
  // 2. Check if the amount is positive (payment amounts typically should be)
  if (parsedAmount <= 0) {
    return {
      isValid: false,
      errorMessage: "Amount must be greater than zero.",
    };
  }
  // 3. (Optional) Check against minAmount
  if (minAmount !== undefined && parsedAmount < minAmount) {
    return {
      isValid: false,
      errorMessage: `Amount must be at least ${minAmount}.`,
    };
  }
  // 4. (Optional) Check against maxAmount
  if (maxAmount !== undefined && parsedAmount > maxAmount) {
    return {
      isValid: false,
      errorMessage: `Amount cannot exceed ${maxAmount}.`,
    };
  }

  // 5. (Optional, for stricter currency format) Check for valid decimal places
  // This regex allows for a decimal point followed by one or more digits,
  // but it does not restrict the number of decimal places.
  const currencyRegex = /^\d+(\.\d+)?$/;
  if (!currencyRegex.test(amount)) {
    return {
      isValid: false,
      errorMessage: "Please enter a valid currency format (e.g., 10 or 10.50).",
    };
  }
  return { isValid: true, errorMessage: "" };
}
export const launchEsSignup = (isAisensy = false, cusId) => {
  if (isAisensy) {
    localStorage.setItem("cusId", cusId);
    localStorage.setItem("partner", "aisensy");
    window.launchWhatsAppSignup("1240838350783888");
  } else {
    localStorage.setItem("cusId", cusId);
    localStorage.setItem("partner", "haptik");
    window.launchWhatsAppSignup("1108770184427834");
  }
};
